import { render, staticRenderFns } from "./SignInForm.vue?vue&type=template&id=2d81bcda&scoped=true&"
import script from "./SignInForm.vue?vue&type=script&lang=js&"
export * from "./SignInForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d81bcda",
  null
  
)

export default component.exports